import { useEffect } from "react";
import { useApp } from "../context/AppContext";
import CalendarView from "../views/CalendarView";

export default function CalendarPage() {
  const ctx = useApp();

  useEffect(() => {
    ctx.setCalendarMonth(new Date());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <CalendarView
      terms={ctx.terms} activeTerm={ctx.activeTerm} lectures={ctx.lectures}
      showTermForm={ctx.showTermForm} setShowTermForm={ctx.setShowTermForm}
      termForm={ctx.termForm} setTermForm={ctx.setTermForm} termLoading={ctx.termLoading}
      handleCreateTerm={ctx.handleCreateTerm} editingTerm={ctx.editingTerm}
      setEditingTerm={ctx.setEditingTerm} editTermForm={ctx.editTermForm}
      setEditTermForm={ctx.setEditTermForm} editTermLoading={ctx.editTermLoading}
      handleSaveEditTerm={ctx.handleSaveEditTerm} handleEditTerm={ctx.handleEditTerm}
      handleSelectTerm={ctx.handleSelectTerm} handleDeleteTerm={ctx.handleDeleteTerm}
      handleDuplicateTerm={ctx.handleDuplicateTerm} selectedLecture={ctx.selectedLecture}
      lectureEdit={ctx.lectureEdit} setLectureEdit={ctx.setLectureEdit}
      handleSelectLecture={ctx.handleSelectLecture} handleSaveLecture={ctx.handleSaveLecture}
      savingLecture={ctx.savingLecture} toggleLectureFile={ctx.toggleLectureFile}
      toggleLectureDay={ctx.toggleLectureDay} calendarMonth={ctx.calendarMonth}
      setCalendarMonth={ctx.setCalendarMonth} showApplySyllabus={ctx.showApplySyllabus}
      setShowApplySyllabus={ctx.setShowApplySyllabus} applySyllabusFile={ctx.applySyllabusFile}
      setApplySyllabusFile={ctx.setApplySyllabusFile} applySyllabusFolder={ctx.applySyllabusFolder}
      setApplySyllabusFolder={ctx.setApplySyllabusFolder} folders={ctx.folders}
      applyingSyllabus={ctx.applyingSyllabus} handleApplySyllabus={ctx.handleApplySyllabus}
      applyMessage={ctx.applyMessage} setApplyMessage={ctx.setApplyMessage}
      fetchFiles={ctx.fetchFiles} files={ctx.files} allLectures={ctx.allLectures}
      applySyllabusTermId={ctx.applySyllabusTermId} setApplySyllabusTermId={ctx.setApplySyllabusTermId}
      handleRescheduleLecture={ctx.handleRescheduleLecture} handleUpdateTag={ctx.handleUpdateTag}
    />
  );
}